// extracted by css-extract-rspack-plugin
export default {"drawer":"aobc5svIlpwRmaU0","header":"q3zrEebVhZQtytrK","content":"LLUMgl1NrJUEQdEJ"};